import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Button, Modal, Text, WrapperFlex } from '@unimed-fesp/components';

import { ModalContentWrapper } from '../../molecules/Modal';

import { ContentText, CheckboxWithText } from './styles';

import theme from '../../../styles/theme';

function ModalTermoMassaInicial({
  isOpen,
  onClick,
  aceitos,
  setAceitos,
  handleValidadMassaInicial,
}) {
  const { success } = useSelector((state) => state.lista.MassaInicial.patch);

  function handleChange(value) {
    if (aceitos.includes(value)) {
      setAceitos((state) => state.filter((item) => item !== value));
    } else {
      setAceitos((state) => [...state, value]);
    }
  }

  if (success) return <ModalSucessoPatch isOpen={isOpen} onClick={onClick} />;

  return (
    <Modal
      isOpen={isOpen}
      onClick={onClick}
      height={518}
      width={460}
      tipo="warning"
      footer={
        <ModalFooter
          onClick={onClick}
          aceitos={aceitos}
          handleValidadMassaInicial={handleValidadMassaInicial}
        />
      }
    >
      <ModalContentWrapper>
        <ContentText>
          <Text
            font="15px 'Calibri Regular'"
            center
            color={theme.colorGray}
            text="Este processo identificará inconsistências de formatação,
            preenchimento e validação dos dados de massa inicial"
          />
          <WrapperFlex column marginTop={50} width={350} marginLeft={15}>
            <CheckboxWithText
              value="compartilhar"
              checked={aceitos.includes('compartilhar')}
              label="Aceito compartilhar a massa inicial, com a Fesp, caso não existam inconsistência"
              onClick={() => handleChange('compartilhar')}
            />
            <CheckboxWithText
              value="termo"
              checked={aceitos.includes('termo')}
              label={
                <>
                  Li e concordo com o
                  <Link
                    to="/novo/massa-inicial/termo-responsabilidade"
                    target="_blank"
                  >
                    {' '}
                    Termo de responsabilidade
                  </Link>
                </>
              }
              onClick={() => handleChange('termo')}
            />
          </WrapperFlex>
        </ContentText>
      </ModalContentWrapper>
    </Modal>
  );
}

const ModalFooter = ({ onClick, aceitos, handleValidadMassaInicial }) => {
  return (
    <WrapperFlex justifySpaceAround flex>
      <Button
        tipo="secondary"
        type="button"
        paddingTop={8}
        paddingRight={8}
        paddingBottom={8}
        paddingLeft={8}
        width={100}
        alignCenter
        justifyCenter
        font="16px unimed_slabregular"
        onClick={onClick}
      >
        cancelar
      </Button>
      <Button
        tipo="primary"
        type="button"
        paddingTop={8}
        paddingRight={8}
        paddingBottom={8}
        paddingLeft={8}
        width={180}
        alignCenter
        justifyCenter
        disabled={aceitos && !aceitos.includes('termo')}
        font="16px unimed_slabregular"
        onClick={handleValidadMassaInicial}
      >
        validar massa inicial
      </Button>
    </WrapperFlex>
  );
};

const ModalSucessoPatch = ({ isOpen, onClick }) => {
  function voltarParaMassaInicial() {
    window.location.reload();
  }

  return (
    <Modal
      isOpen={isOpen}
      onClick={voltarParaMassaInicial}
      height={450}
      width={460}
      tipo="success"
      footer={
        <Button
          tipo="primary"
          type="button"
          paddingTop={8}
          paddingRight={8}
          paddingBottom={8}
          paddingLeft={8}
          width={100}
          alignCenter
          justifyCenter
          font="16px unimed_slabregular"
          onClick={voltarParaMassaInicial}
        >
          ok
        </Button>
      }
    >
      <ModalContentWrapper>
        <ContentText>
          <Text
            font="15px 'Calibri Regular'"
            center
            color={theme.colorGray}
            text="O arquivo de massa inicial foi enviado."
          />
          <br />
          <Text
            font="15px 'Calibri Regular'"
            center
            color={theme.colorGray}
            text="Realizaremos a validação do arquivo disponibilizado. Aguarde, pois
          em breve lhe enviaremos um e-mail contendo o resultado da validação."
          />
        </ContentText>
      </ModalContentWrapper>
    </Modal>
  );
};
export default ModalTermoMassaInicial;
